import { render, staticRenderFns } from "./bv-view.vue?vue&type=template&id=1731b1c3&scoped=true&"
import script from "./bv-view.vue?vue&type=script&lang=js&"
export * from "./bv-view.vue?vue&type=script&lang=js&"
import style0 from "./bv-view.vue?vue&type=style&index=0&id=1731b1c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../apps/life_driving_school/node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1731b1c3",
  null
  
)

export default component.exports